import { render } from "./TentangKSD.vue?vue&type=template&id=7997b82f"
import script from "./TentangKSD.vue?vue&type=script&lang=js"
export * from "./TentangKSD.vue?vue&type=script&lang=js"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__